const KEY = 'userToken';

export function getAuthToken() {
    const userToken = localStorage.getItem(KEY);
    const token = PSPCustomization.getAuthToken() ?? userToken ?? null; // check on share token

    return token;
}